<script setup lang="ts">
import TheNavbar from '@/components/TheNavbar.vue';
import TheSidebar from '@/components/TheSidebar.vue';

const route = useRoute();
</script>

<template>
  <v-layout>
    <ClientOnly>
      <TheSidebar />
    </ClientOnly>

    <v-main>
      <TheNavbar />

      <NuxtPage :page-key="(route) => route.fullPath" />
    </v-main>
  </v-layout>
</template>

<style></style>
